import React from 'react';
import { isBooleanTrue } from '../../shared/objectUtils';
import InvoiceCell from '../InvoiceCell/InvoiceCell';
import InvoiceRow from '../InvoiceRow/InvoiceRow';

const InvoiceRows = ({ data, columns }) => {
    const createDataRows = (data, columns) => {
        let dataRows = [];

        let i = 0;
        for (const row of data) {
            let dataRow = [];
            columns.forEach((column, index) => {
                let key = column.key;
                dataRow.push(<InvoiceCell key={`invoice-cell-${index}`} value={row[key]} colSpan={(column.colSpan ? column.colSpan : 1)} columnKey={column.key} dataType={(column.dataType ? column.dataType : 'String')} textAlign={(column.textAlign ? column.textAlign : 'left')} isCancelled={isBooleanTrue(row.isCancelled)} />);
            });

            dataRows.push(<InvoiceRow key={`invoice-row-${i}`} dataRow={dataRow} />);
            i++;
        }

        return dataRows;
    };

    return createDataRows(data, columns);
};

export default InvoiceRows;